// SPDX-License-Identifier: AGPL-3.0-or-later

import type { Finding } from '@intakeform/ui';

/**
 * What to show after "Flagged because:". A `contradiction` code is replaced by
 * the short labels of the rules that fired (e.g. "PHQ-9: self-harm answer"),
 * when they have one; every other code is shown as is.
 */
export function flagReasons(
  flaggedCodes: readonly string[],
  findings: readonly Finding[],
): string[] {
  const out: string[] = [];
  for (const code of flaggedCodes) {
    const labels =
      code === 'contradiction'
        ? findings
            .filter((f) => f.code === 'contradiction' && f.severity === 'error')
            .map((f) => f.context?.['label'])
            .filter((l): l is string => typeof l === 'string' && l !== '')
        : [];
    for (const reason of labels.length > 0 ? labels : [code]) {
      if (!out.includes(reason)) out.push(reason);
    }
  }
  return out;
}
